/**
 * Apollo Client factory for unity/base Vite SPA.
 * ADR-006, ADR-020, E32 T-3901.
 *
 * Connects to VITE_GRAPHQL_URL (defaults to api.unity.dev/v1/graphql in prod).
 * Auth header is injected from the session cookie (httpOnly) — Hasura reads
 * the cookie directly via the configured hasura-auth JWT mode.
 */

import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client'

const uri =
  (import.meta.env['VITE_GRAPHQL_URL'] as string | undefined) ??
  'https://api.unity.dev/v1/graphql'

const httpLink = createHttpLink({
  uri,
  credentials: 'include', // send auth cookie to Hasura
})

export const apolloClient = new ApolloClient({
  link: httpLink,
  cache: new InMemoryCache(),
  defaultOptions: {
    watchQuery: { fetchPolicy: 'cache-and-network' },
  },
})
